export const classNames = (...classes: Array<string | Record<string, boolean>>) => classes.reduce<string[]>(
  (acc, className) => {
    if (typeof className === "string") {
      acc.push(className);
    } else {
      acc.push(...Object.entries(className).filter(([_, value]) => value).map(([key, _]) => key));
    }
    return acc;
  }, []).filter(n => Boolean(n.trim())).join(" ");